module.exports = __webpack_public_path__ + "static/media/apple-btn.4d4ab56e.webp";